import { render, staticRenderFns } from "./ShowModule.vue?vue&type=template&id=ae60d112&scoped=true&"
import script from "./ShowModule.vue?vue&type=script&lang=js&"
export * from "./ShowModule.vue?vue&type=script&lang=js&"
import style0 from "./ShowModule.vue?vue&type=style&index=0&id=ae60d112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae60d112",
  null
  
)

export default component.exports